module.exports = __webpack_public_path__ + "static/media/cctv.c0478929.jpg";